import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CreditCard, Phone, Calendar } from "lucide-react";
import { trackEvent } from "@/hooks/useBusinessData";

export default function PayBlock({ config }) {
  return (
    <section
      id="pay"
      className="relative bg-white text-black py-24 md:py-36 overflow-hidden"
      data-testid="pay-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-14">
          <div className="col-span-12 md:col-span-6">
            <div className="font-mono uppercase tracking-[0.28em] text-[10px] text-zinc-500 mb-6">
              § Pay for your service
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="font-serif text-4xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight"
            >
              Secure card
              <br />
              <span className="italic text-zinc-500">payment.</span>
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:pl-8">
            <p className="text-zinc-700 text-base md:text-lg leading-relaxed max-w-md">
              Card payments powered by Stripe are launching soon. In the meantime, pay in-studio, book by phone, or reserve online with Calendly.
            </p>
          </div>
        </div>

        <div className="border border-black/15 p-8 md:p-14 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
            <div>
              <CreditCard className="w-8 h-8" strokeWidth={1.2} />
              <div className="font-serif text-2xl md:text-3xl mt-4">
                Card in Studio
              </div>
              <p className="text-zinc-600 mt-2 leading-relaxed">
                We accept all major cards, tap-to-pay, and Apple / Google Pay at the chair.
              </p>
            </div>
            <div>
              <Calendar className="w-8 h-8" strokeWidth={1.2} />
              <div className="font-serif text-2xl md:text-3xl mt-4">
                Reserve Online
              </div>
              <p className="text-zinc-600 mt-2 leading-relaxed">
                Lock in your appointment with Calendly and settle in-studio when you arrive.
              </p>
              <Link
                to="/book"
                onClick={() => trackEvent("book_clicked", { source: "pay_block" })}
                className="inline-flex items-center gap-3 mt-4 font-mono uppercase tracking-[0.22em] text-xs line-hover"
                data-testid="pay-book-cta"
              >
                Book now
              </Link>
            </div>
            <div>
              <Phone className="w-8 h-8" strokeWidth={1.2} />
              <div className="font-serif text-2xl md:text-3xl mt-4">
                Call the Studio
              </div>
              <p className="text-zinc-600 mt-2 leading-relaxed">
                Prefer a personal touch? Call us and we'll take it from there.
              </p>
              <a
                href={`tel:${config.phone_tel}`}
                onClick={() => trackEvent("call_clicked", { source: "pay_block" })}
                className="inline-flex items-center gap-3 mt-4 font-mono uppercase tracking-[0.22em] text-xs line-hover"
                data-testid="pay-call-cta"
              >
                {config.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
